import { render, staticRenderFns } from "./OrderType.vue?vue&type=template&id=a4124a5c&scoped=true&"
import script from "./OrderType.vue?vue&type=script&lang=js&"
export * from "./OrderType.vue?vue&type=script&lang=js&"
import style0 from "./OrderType.vue?vue&type=style&index=0&id=a4124a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4124a5c",
  null
  
)

/* custom blocks */
import block0 from "./OrderType.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports